import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchChassisForQualityAssuranceOrders = () => apiActionCreator({
  'endpoint': '/quality-assurance/orders/chassis',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_CHASSIS_AVAILABLE,
    ActionTypes.FETCHED_CHASSIS_AVAILABLE,
    [
      ActionTypes.FETCHED_CHASSIS_AVAILABLE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchingCommentsOtherOrdersByChassis = (chassis) => apiActionCreator({
  'endpoint': `/accessories/chassis/${chassis}/comments`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_COMMENTS_BY_CHASSIS,
    ActionTypes.FETCHED_COMMENTS_BY_CHASSIS,
    [
      ActionTypes.FETCHED_COMMENTS_BY_CHASSIS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchQualityAssuranceOrder = (order) => apiActionCreator({
  'endpoint': `/quality-assurance/orders/${order}/00`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_QUALITY_ASSURANCE_ORDER,
    ActionTypes.FETCHED_QUALITY_ASSURANCE_ORDER,
    [
      ActionTypes.FETCHED_QUALITY_ASSURANCE_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
